jQuery(function($){

	$('.js-premium-landing-chart').each(function() {

		var enableStandardOverlay = (enableJoinOverlay === 'yes') ? true : false;


		if (enableStandardOverlay) {

			$('.js-standard-membership').hover(
				function() {
					$('.js-standard-membership').addClass('chart-overlay-override');
					$('.js-standard-membership').find('.js-normal-version').hide();
					$('.js-standard-membership').find('.js-overlay-version').css('display', 'flex');
				},
				function() {
					$('.js-standard-membership').removeClass('chart-overlay-override');
					$('.js-standard-membership').find('.js-normal-version').css('display', 'flex');
					$('.js-standard-membership').find('.js-overlay-version').hide();
				}
			);

			$('body').on('click', '.js-standard-membership', function () {

				window.location.href = "/account/register";
			});
		}

		$('.js-premium-membership').hover(
			function() {
				$('.js-premium-membership').addClass('chart-overlay-override');
				$('.js-premium-membership').find('.js-normal-version').hide();
				$('.js-premium-membership').find('.js-overlay-version').css('display', 'flex');
			},
			function() {
				$('.js-premium-membership').removeClass('chart-overlay-override');
				$('.js-premium-membership').find('.js-normal-version').css('display', 'flex');
				$('.js-premium-membership').find('.js-overlay-version').hide();
			}
		);

		$('body').on('click', '.js-premium-membership', function () {

			window.location.href = "/start-premium-purchase";
		});
	});
});